import { all, fork } from 'redux-saga/effects';

import subscriptionProductSagas from './subscription/sagas';
import addonSagas from './addon/sagas';

export default function* billingSagas() {
  yield all([
    fork(subscriptionProductSagas),
    fork(addonSagas),
  ]);
}
